import React from 'react';
import styled from 'styled-components';

type VimeoEmbedProps = {
  src: string;
  width?: number;
  height?: number;
};

const VimeoEmbed: React.FC<VimeoEmbedProps> = ({ src, width = 800, height = 450 }) => {
  const dimensionPadding = (height / width) * 100;

  const embedCode = `<iframe className="vimeo" loading="lazy" width="${width}" height="${height}" src="${src}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;

  return <EmbedStyled padding={dimensionPadding} dangerouslySetInnerHTML={{ __html: embedCode }} />;
};

type EmbedStyleProps = {
  padding: number;
};

const EmbedStyled = styled.div<EmbedStyleProps>`
  width: 100%;
  position: relative;
  padding-bottom: ${(props) => props.padding}%;
  height: 0;
  overflow: hidden;
  margin: 1.5rem 0;

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export default VimeoEmbed;
